module.exports = __webpack_public_path__ + "img/6.a20e3c62.jpg";